import React from "react";
import { Card } from "../modules/Settings/Laboratories";

export function LaboratoryCardPage(props) {
  return <Card {...props} />;
}
